export default function map(arr, fn) {
    var res = [],
        i,
        arrLen = arr.length;
    for (i = 0; i < arrLen; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/utils/map.js
// module id = 883
// module chunks = 3